<template>
  <button
    v-bind="$attrs"
    v-on="$listeners"
    :type="type"
    :disabled="loading || disabled"
    class="btn btn-primary"
    :class="{ 'btn-lg': size === 'large' }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :style="buttonStyle"
  >
    <template v-if="loading">
      <beat-loader :color="style.colorPrimaryButtonText"></beat-loader>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

export default {
  components: {
    BeatLoader
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  data() {
    return {
      hover: false
    };
  },
  computed: {
    ...mapGetters('settings', ['company', 'style']),
    buttonStyle() {
      return {
        'background-color': this.disabled ? 'grey' : this.style.colorPrimaryButton,
        'border-color': this.style.colorPrimaryButton,
        'box-shadow': this.hover ? '0 0 0 1px ' + this.style.colorPrimaryButton : 'none',
        color: this.style.colorPrimaryButtonText,
        opacity: this.hover ? 0.85 : this.disabled ? 0.5 : 1,
        cursor: this.disabled ? 'not-allowed' : 'pointer'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-primary:active {
  background-image: none;
}
</style>
